import { transform, isArray, camelCase, isObject } from "lodash";

export default function camelize(collection) {
  return transform(collection, (acc, value, key, target) => {
    const camelKey = isArray(target) ? key : camelCase(key);

    acc[camelKey] = isObject(value) ? camelize(value) : value;
  });
}
